"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valle-castellana": {
    "fd4fccc8": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "skipSearch": false
    }],
    "basto": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aafe4a0f": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "skipSearch": false
    }],
    "collegrato": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "48d4c5f4": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "skipSearch": false
    }],
    "laturo": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15555b31": [{
      "hkey": "793e0df7",
      "slug": "macchia-da-borea-macchia-da-sole",
      "name": "Macchia da Borea-Macchia da Sole",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-da-borea": [{
      "hkey": "793e0df7",
      "slug": "macchia-da-borea-macchia-da-sole",
      "name": "Macchia da Borea-Macchia da Sole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "248566df": [{
      "hkey": "793e0df7",
      "slug": "macchia-da-borea-macchia-da-sole",
      "name": "Macchia da Borea-Macchia da Sole",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-da-sole": [{
      "hkey": "793e0df7",
      "slug": "macchia-da-borea-macchia-da-sole",
      "name": "Macchia da Borea-Macchia da Sole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valle-castellana"
    }],
    "f918add7": [{
      "hkey": "1cb3ec72",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "skipSearch": false
    }],
    "pietralta-colle": [{
      "hkey": "1cb3ec72",
      "slug": "colle",
      "name": "Colle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "02eabdc7": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "skipSearch": false
    }],
    "setteceneri": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da80bb8d": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "skipSearch": false
    }],
    "vallenquina": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "773c383c": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "skipSearch": false
    }],
    "vallepezzata-da-borea": [{
      "hkey": "15105d7a",
      "slug": "valle-castellana",
      "name": "Valle Castellana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;